<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-shape</v-icon> <span>{{$t('category.crumb_add')}}</span>
      </h1>

      <div class="mt-16">
        <category method="create"></category>
      </div>
  </section>
</template>
<script>
import Category from '@/components/categories/Category'

export default {
  components: {
    Category
  },
  beforeCreate(){
    document.title = "Report Lake - " + this.$t('category.crumb_add');
  },
  data: () => ({
    
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "categories.create"])) {
      this.$router.push('/admin');
    }

  },
  methods:{
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin',
          exact: true,
        },
        {
          text: this.$t('menu.category_management'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin/workers-settings/categories',
          exact: true,
        },
        {
          text: this.$t('category.crumb_add'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
